import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-results',
  templateUrl: './home-results.component.html',
  styleUrls: ['./home-results.component.scss'],
})
export class HomeResultsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
